// extracted by mini-css-extract-plugin
export default {"documentsContainer":"DisputeDocuments_documentsContainer__4SmJ+","documents":"DisputeDocuments_documents__+NPYY","documentsTitle":"DisputeDocuments_documentsTitle__mkCLz"};